import { render, staticRenderFns } from "./TEImage.vue?vue&type=template&id=1df566c0"
import script from "./TEImage.vue?vue&type=script&lang=js"
export * from "./TEImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports